var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "remix-icons/fill/business/calendar-2-fill",
    clipPath: "url(#clip0_905_3196)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.5415 2.12467H15.3748C15.5627 2.12467 15.7429 2.1993 15.8757 2.33214C16.0085 2.46498 16.0832 2.64515 16.0832 2.83301V14.1663C16.0832 14.3542 16.0085 14.5344 15.8757 14.6672C15.7429 14.8 15.5627 14.8747 15.3748 14.8747H2.62484C2.43698 14.8747 2.25681 14.8 2.12397 14.6672C1.99113 14.5344 1.9165 14.3542 1.9165 14.1663V2.83301C1.9165 2.64515 1.99113 2.46498 2.12397 2.33214C2.25681 2.1993 2.43698 2.12467 2.62484 2.12467H5.45817V0.708008H6.87484V2.12467H11.1248V0.708008H12.5415V2.12467ZM3.33317 6.37467V13.458H14.6665V6.37467H3.33317ZM4.74984 7.79134H6.1665V9.20801H4.74984V7.79134ZM8.2915 7.79134H9.70817V9.20801H8.2915V7.79134ZM11.8332 7.79134H13.2498V9.20801H11.8332V7.79134Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_905_3196"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.1af20c0a6650aa84a9fd773b1c4543ef.svg";
export { ForwardRef as ReactComponent };